import {get, post} from "./index";
import {applicationName} from "../utils";

//媒体列表
export const getMediaList =(param, callBack) => {
   get("/cm-sites-" + applicationName()+`/media/getByCurrentUser`, {time: new Date().getTime(),...param}, callBack)
}

// 素材库 稿件列表
export const getMaterialList = (param, callBack) => {
    get("/cm-sites-" + applicationName()+`/material/getStuffListByMediaCode`, {time: new Date().getTime(),...param}, callBack)
}

//其他稿件 根据resourceId查询稿件信息
export const getManuscriptById = (param, callBack) => {
    get("/cm-sites-" + applicationName()+`/showResource/getByResourceId`, {time: new Date().getTime(),...param}, callBack)
}